module.exports = __webpack_public_path__ + "img/illustration-features-tab-1.25a23733.svg";